import React, { useState, useRef } from 'react'
import { useSelector } from 'react-redux';

export const ModalFactura = ({ onSubmit }) => {
    const [docfact, setDocFact] = useState('')
    const [nameExtencion, setNameExtencion] = useState()
    const [disablebutton, setDisablebutton] = useState(false)
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')
    const submitting = useRef(false)
    const userdatos = useSelector(state => state.userInfo)

    const handleInputChange = (e) => {
        const imagen = e.target.files[0]
        if (!imagen) return;
        setDocFact(imagen);
        const fileName = e.target.files[0].name;
        const fileExtension = fileName.split('.').pop().toLowerCase();
        setNameExtencion(fileExtension);
        setDisablebutton(true)
    };
    
    const handleSubmit = async () => {
        if (submitting.current) return;
        setError('');
        if (userdatos?.restringirFacturacion) {
            setError('La facturación está restringida. No puede realizar esta acción.');
            return;
        }
        submitting.current = true;
        setSaving(true);
        try {
            await onSubmit(docfact, nameExtencion);
            setDocFact('');
            setDisablebutton(false);
        } catch (error) {
            setError(error?.message || 'No se pudo guardar la factura. Verifique el registro antes de volver a intentar.');
        } finally {
            submitting.current = false;
            setSaving(false);
        }
    };

    return (
        <div className="modal fade" id="modalFactura" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Cargar Factura</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <input type="file" aria-label="Archivo de factura" accept=".jpg,.jpeg,.png,.pdf,.jfif" capture='environment' disabled={saving} onChange={handleInputChange}/>
                        {error && <p role="alert">{error}</p>}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                        {disablebutton && 
                            <button type="button" className="btn btn-primary" disabled={saving} onClick={handleSubmit}>{saving ? 'Guardando factura…' : 'Guardar Factura'}</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};
